// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1nNWa","bigColWidth":"Table_bigColWidth__3Bk5E","biggerColWidth":"Table_biggerColWidth__3OFyQ","row":"Table_row__3fWQ2","col":"Table_col__1DL33"};